import {v4 as uuidv4} from 'uuid';

export default {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  setLibraries(state, libraries) {
    state.libraries = libraries.map(l => {
      l.active = false;
      return l;
    });
  },
  setTemplates(state, data) {
    const templates = data.content.map(t => {
      t.version = uuidv4();
      return t;
    });
    state.pageCount = data.totalPages;
    state.templates = templates;
  },
  updateTemplate(state, template) {
    template.version = uuidv4();
    const templates = state.templates.map(t => {
      if (t.id === template.id) {
        return template;
      }

      return t;
    });
    state.templates = templates;
  },
  activateLibrary(state, libraryId) {
    state.currentPage = 1;
    state.libraries = state.libraries.map(l => {
      l.active = l.id === libraryId;
      return l;
    });
  },
  setPage(state, page) {
    state.currentPage = page;
  },
  toggleEditor(state) {
    state.editorOpen = !state.editorOpen;
  },
  setError(state, error) {
    state.error = error;
  },
  setTemplateData(state, data) {
    state.templateData = data;
  },
  setCustomer(state, customer) {
    state.customer = customer;
  },
  openEditor(state) {
    state.editorOpen = true;
  },
  closeEditor(state) {
    state.editorOpen = false;
  },
  setConflict(state, conflict) {
    state.conflict = conflict;
  },
  setDestinationLibrary(state, destinationLibrary) {
    state.destinationLibrary = destinationLibrary;
  },
  setTemplateName(state, templateName) {
    state.templateName = templateName;
  },
  setNewTemplateName(state, newTemplateName) {
    state.newTemplateName = newTemplateName;
  },
  setTemplateId(state, templateId) {
    state.templateId = templateId;
  },
  setSuccess(state, success) {
    state.success = success;
  },
  setCurrentTemplate(state, template) {
    state.dirtyTemplate = template;
  },
  setCurrentHTMLTemplate(state, HTMLtemplate) {
    state.dirtyTemplateHTML = HTMLtemplate;
  },
  setOpenSaveModal(state, value) {
    state.openSaveModal = value;
  },
  setLoadingTemplates(state, loadingTemplates) {
    state.loadingTemplates = loadingTemplates;
  },
  setLoadingTemplate(state, loadingTemplate) {
    state.loadingTemplate = loadingTemplate;
  },
  setLoadingLibraries(state, loadingLibraries) {
    state.loadingLibraries = loadingLibraries;
  },
  setSavingTemplate(state, savingTemplate) {
    state.savingTemplate = savingTemplate;
  },
  setRenamingTemplate(state, renamingTemplate) {
    state.renamingTemplate = renamingTemplate;
  },
  setShowUseModal(state, showUseModal) {
    state.showUseModal = showUseModal;
  },
  setInfo(state, info) {
    state.info = info;
  },
  setWarning(state, warning) {
    state.warning = warning;
  },
  incrementLibrarySize(state, libraryId) {
    state.libraries = state.libraries.map(l => {
      if (l.id === libraryId) {
        l.size++;
      }

      return l;
    });
  },
  decrementLibrarySize(state, libraryId) {
    state.libraries = state.libraries.map(l => {
      if (l.id === libraryId) {
        l.size--;
      }

      return l;
    });
  },
  setNewsletter(state, newsletter) {
    state.newsletter = newsletter;
  },
  setDuplicateTemplate(state, duplicateTemplate) {
    state.duplicateTemplate = duplicateTemplate;
  },
  setDuplicateTemplateData(state, duplicateTemplateData) {
    state.duplicateTemplateData = duplicateTemplateData;
  },
  setLoadApplication(state, loadApplication) {
    state.loadApplication = loadApplication;
  },
  saveCredentials(state, accessToken) {
    state.loadApplication = true;
    state.accessToken = accessToken;
  },
  clearCredentials(state) {
    state.loadApplication = false;
    state.accessToken = undefined;
  },
  setHideUseButton(state, hideUseButton) {
    state.hideUseButton = hideUseButton;
  },
  setCustomMessage(state, customMessage) {
    state.customMessage = customMessage;
  },
  appendMergeTagsSources(state, mergeTagsSources) {
    state.mergeTagsSources = [...state.mergeTagsSources, ...mergeTagsSources];
  },
  setUserDb(state, userDb) {
    state.userDb = userDb;
  },
  setMergeTagsSource(state, mergeTagsSource) {
    state.mergeTagsSource = mergeTagsSource;
  },
  setDisplayConditionsOpen(state, displayConditionsOpen) {
    state.displayConditionsOpen = displayConditionsOpen;
  },
  setDisplayConditionSaved(state, displayConditionSaved) {
    state.displayConditionSaved = displayConditionSaved;
  },
  setDynamicContentsOpen(state, dynamicContentsOpen) {
    state.dynamicContentsOpen = dynamicContentsOpen;
  },
  setSaveRowOpen(state, saveRowOpen) {
    state.saveRowOpen = saveRowOpen;
  },
  setSaveRowPromise(state, {resolve, reject}) {
    state.saveRowPromise = {resolve, reject};
  },
  setSaveRowData(state, saveRowData) {
    state.saveRowData = saveRowData;
  },
  setEditRowExternalDialog(state, editRowExternalDialog) {
    state.editRowExternalDialog = editRowExternalDialog;
  },
  setExternalContentUrlsOpen(state, externalContentUrlsOpen) {
    state.externalContentUrlsOpen = externalContentUrlsOpen;
  },
  setExternalContentUrlsModified(state, externalContentUrlsModified) {
    state.externalContentUrlsModified = externalContentUrlsModified;
  },
  setDynamicContentsSaved(state, dynamicContentsSaved) {
    state.dynamicContentsSaved = dynamicContentsSaved;
  },
  setFilterTemplateName(state, filterTemplateName) {
    state.filterTemplateName = filterTemplateName;
  },
  setCustomerTags(state, customerTags) {
    state.customerTags = customerTags;
  },
  setSelectedTags(state, selectedTags) {
    state.selectedTags = selectedTags;
  },
  setPendingTags(state, pendingTags) {
    state.pendingTags = pendingTags;
  },
  setDeleteTagsModal(state, deleteTagsModal) {
    state.deleteTagsModal = deleteTagsModal;
  },
  setSection(state, section) {
    state.section = section;
  },
  openTemplateSection(state) {
    state.section = 'templates';
  },
  openDynamicSection(state) {
    state.section = 'dynamic';
  },
  setDynamicContents(state, dynamicContents) {
    state.dynamicContents = dynamicContents;
  },
  setIsCustomerCare(state, isCustomerCare) {
    state.isCustomerCare = isCustomerCare;
  },
  setHtmlTest(state, htmlTest) {
    state.htmlTest = htmlTest;
  },
  setShowTestModal(state, showTestModal) {
    state.showTestModal = showTestModal;
  }
};
